export const getBaseUrl = () => {
  return process.env.NODE_ENV === "development"
    ? "http://localhost:3030"
    : "https://email-server-m1-28c7a3b83f1b.herokuapp.com";
};
